import { FC, ReactNode } from 'react';
import { InputAdornment, InputAdornmentProps } from '@mui/material';

import { Hint } from '@components/base';

export type TextFieldHintProps = {
  hint: ReactNode;
  position: InputAdornmentProps['position'];
};

export const TextFieldHint: FC<TextFieldHintProps> = ({ hint, position }) => (
  <InputAdornment position={position}>
    <Hint icon='info' tooltip={hint} />
  </InputAdornment>
);
